import { getCurrentInstance, watch, Ref } from 'vue';
import { domainStore } from '@/store/domain-store';

export default function (lang: Ref<string>) {
  const instance = getCurrentInstance();

  console.log('initital: ' + lang.value);

  // update lang in store if language-ref changes value
  // mostly required for local env, in production language change should always trigger-page-load
  watch(lang, (newLang, oldLang) => {
    if (newLang && newLang != oldLang) {
      domainStore.updateLanguage(newLang);
      // instance?.proxy?.$forceUpdate();
    }
  });
}
